import React from "react";
import { CheckCircle2 } from "lucide-react";

const cls = "w-full rounded-xl border-2 border-[#E2EBF0] px-3 py-2.5 text-sm focus:border-[#008057] outline-none bg-white";
const GENDERS = ["Male", "Female", "Prefer not to say"];
const CONSENTS = [
  ["guardian_confirm", "I am the participant's parent or authorized legal guardian."],
  ["terms", "I accept the camp's registration terms and conditions."],
  ["privacy", "I acknowledge the privacy policy."],
  ["medical_share", "I acknowledge medical info may be shared with authorized camp staff for safety."],
];

const SizeSelect = ({ label, options, onChange, testId }) => (
  <select data-testid={testId} className={cls} onChange={(e) => onChange(e.target.value)}>
    <option value="">{label}</option>{options.map((s) => <option key={s}>{s}</option>)}
  </select>
);

export const DoneMessage = ({ done }) => (
  <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="sponsored-done">
    <CheckCircle2 className="mx-auto text-[#008057]" size={64} />
    <h1 className="font-display text-3xl font-extrabold text-[#03281B] mt-6">Registration Complete</h1>
    <p className="text-slate-600 mt-2">{done === "already" ? "This sponsored registration has already been completed." : <>Your child's sponsored place is confirmed. Reference <b>{done}</b>. Nothing to pay - the camp fee is covered by the sponsor.</>}</p>
  </div>
);

const MedicalFields = ({ p, setP }) => (
  <>
    <label className="flex items-center gap-2 mt-3 text-sm"><input type="checkbox" className="accent-[#008057]" checked={p.medical?.none} onChange={(e) => setP({ medical: { none: e.target.checked, details: e.target.checked ? "" : p.medical?.details } })} /> No medical considerations or allergies</label>
    {!p.medical?.none && <textarea className={`${cls} mt-2`} placeholder="Medical / allergy details" onChange={(e) => setP({ medical: { none: false, details: e.target.value } })} />}
  </>
);

export const ParticipantFields = ({ p, setP, sizes }) => (
  <div>
    <div className="font-display font-bold text-lg text-[#03281B] mb-3">Participant</div>
    <div className="grid sm:grid-cols-2 gap-3">
      <input data-testid="sponsored-p-first" className={cls} placeholder="First name" value={p.first_name || ""} onChange={(e) => setP({ first_name: e.target.value })} />
      <input data-testid="sponsored-p-last" className={cls} placeholder="Last name" value={p.last_name || ""} onChange={(e) => setP({ last_name: e.target.value })} />
      <input data-testid="sponsored-p-dob" type="date" className={cls} onChange={(e) => setP({ dob: e.target.value })} />
      <SizeSelect testId="sponsored-p-gender" label="Gender" options={GENDERS} onChange={(v) => setP({ gender: v })} />
      <SizeSelect testId="sponsored-p-tshirt" label="T-shirt size" options={sizes.tshirt} onChange={(v) => setP({ tshirt_size: v })} />
      <SizeSelect testId="sponsored-p-shorts" label="Shorts size" options={sizes.shorts} onChange={(v) => setP({ shorts_size: v })} />
      <SizeSelect testId="sponsored-p-socks" label="Socks size" options={sizes.socks} onChange={(v) => setP({ socks_size: v })} />
    </div>
    <MedicalFields p={p} setP={setP} />
  </div>
);

const GUARDIAN = [["first_name", "First name"], ["last_name", "Last name"], ["email", "Email"], ["phone", "Phone"]];

export const GuardianFields = ({ setG }) => (
  <div>
    <div className="font-display font-bold text-lg text-[#03281B] mb-3">Parent / Legal Guardian</div>
    <div className="grid sm:grid-cols-2 gap-3">
      {GUARDIAN.map(([k, ph]) => <input key={k} data-testid={`sponsored-g-${k}`} className={cls} placeholder={ph} onChange={(e) => setG({ [k]: e.target.value })} />)}
    </div>
  </div>
);

export const ConsentFields = ({ c, setC }) => (
  <div className="space-y-2">
    {CONSENTS.map(([k, l]) => (
      <label key={k} className="flex items-start gap-2 text-sm cursor-pointer"><input data-testid={`sponsored-consent-${k}`} type="checkbox" className="accent-[#008057] mt-0.5" checked={!!c[k]} onChange={(e) => setC({ [k]: e.target.checked })} /> <span>{l} <span className="text-red-500">*</span></span></label>
    ))}
  </div>
);
